module.exports = __webpack_public_path__ + "static/media/WU_FORM_add_minus_retract.07af9e40.svg";